import React from "react";
import AppStackLayout from "component/AppStackLayout/AppStackLayout";

import styles from "./Support.module.css";

import { useGetApplications } from "api/queries/dashboard/applications/Applications";

import SupportContent from "component/support/Support";

function Support() {
  const { data: applications, loading: isLoadingApplications } =
    useGetApplications();
  // const { supportFeedback, setSupportFeedback, mutate, isLoading } =
  //   useContactUs();

  // const onSubmit = (data) => {
  //   mutate(data);
  // };
  return (
    <AppStackLayout activeLink="Contact Us">
      <div className={styles.support}>
        <SupportContent type="in-app" applications={applications} />
      </div>
    </AppStackLayout>
  );
}

export default Support;
